import React from "react";
import "./MediaContent.css"; // Make sure to create this CSS file

const MediaContent = () => {
  return (
    <div className="container">
      <h1 className="title">Publications</h1>
 
      <div className="mediaItem mt-5">
        <a
          href="https://pubmed.ncbi.nlm.nih.gov/15943492/"
          target="_blank"
          rel="noopener noreferrer"
          className="subtitle"
        >
          Lentigo maligna : prognosis and treatment options
        </a>
      </div>

      <div className="mediaItem">
        <a
          href="https://pubmed.ncbi.nlm.nih.gov/21039745/"
          target="_blank"
          rel="noopener noreferrer"
          className="subtitle"
        >
          Basaloid squamous cell carcinoma with 'monster' cells: a mimic of
          pleomorphic basal cell carcinoma
        </a>
      </div>

      <div className="mediaItem">
        <a
          href="https://pubmed.ncbi.nlm.nih.gov/28082377/"
          target="_blank"
          rel="noopener noreferrer"
          className="subtitle"
        >
          A creeping hand eruption
        </a>
      </div>

      <div className="mediaItem">
        <a
          href="https://pubmed.ncbi.nlm.nih.gov/32506524/"
          target="_blank"
          rel="noopener noreferrer"
          className="subtitle"
        >
          Acute generalized exanthematous pustulosis due to dextromethorphan
        </a>
      </div>

      <div className="mediaItem">
        <a
          href="https://pubmed.ncbi.nlm.nih.gov/38233108/"
          target="_blank"
          rel="noopener noreferrer"
          className="subtitle"
        >
          Digital pathology for reporting histopathology samples, including
          cancer screening samples - definitive evidence from a multisite study
        </a>
      </div>

      <h1 className="title mt-5">Media Article </h1>

      <div className="mediaItem mt-5">
        <a
          href="https://www.coventrytelegraph.net/news/local-news/dermatology-expert-says-cover-up-3094443"
          target="_blank"
          rel="noopener noreferrer"
          className="subtitle"
        >
          Dermatology Expert Says Cover Up
        </a>
      </div>
    </div>
  );
};

export default MediaContent;
